module.exports = __webpack_public_path__ + "img/es_Ecran 2.679042bf.png";